<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.search.searchDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择签到日期"
              style="width: 100%;"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.cityNames"
              placeholder="请输入城市"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 数据请求
import { loadStoreVisitCheckInStatisticsListDataApi, loadStoreVisitCheckInStatisticsExportDataApi } from '@/api/storeVisitCheckIn'
export default {
  name: 'DingSignInStatistics',
  components: {
    CustomTable,
    TableOperation
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'sign_in_statistics_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['store_visit_check_in_statistics_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: 'db.visit_date', // 排序字段
            order: 'desc' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            searchDate: '',
            cityNames: ''
          }
        }
      },
      id: null, // 选中的单据ID
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceNames', label: '省区', filterColumn: 'db.province_names', width: 100 },
      { prop: 'cityNames', label: '城市', filterColumn: 'db.city_names' },
      { prop: 'countyNames', label: '区县', filterColumn: 'db.county_names' },
      { prop: 'userName', label: '签到人', filterColumn: 'db.name', width: 120 },
      { prop: 'visitDate', label: '签到日期', filterColumn: 'db.visit_date', width: 110, isBetween: true },
      { prop: 'checkAmount', label: '签到次数', filterColumn: 'db.check_amount', width: 110, isBetween: true },
      { prop: 'reportAmount', label: '报告次数', filterColumn: 'db.report_amount', width: 110, isBetween: true },
      { prop: 'ignoreAmount', label: '忽略次数', filterColumn: 'db.ignore_amount', width: 110, isBetween: true },
      { prop: 'firstDate', label: '当日首次签到时间', filterColumn: 'db.first_date', width: 150, isBetween: true },
      { prop: 'lastDate', label: '当日最后签到时间', filterColumn: 'db.last_date', width: 150, isBetween: true },
      { prop: 'workMinute', label: '首末签到间隔(分钟)', filterColumn: 'db.work_minute', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadStoreVisitCheckInStatisticsListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查询
    searchData () {
      // 重置右键筛选条件
      this.masterList.tableQuery.page = 1
      this.masterList.tableQuery.contextmenuWrap = []
      // 重置排序条件
      this.masterList.tableQuery.sort.prop = 'db.visit_date'
      this.masterList.tableQuery.sort.order = 'desc'
      this.loadTableData()
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadStoreVisitCheckInStatisticsExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
